import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useNotificationStore = defineStore('notification', () => {
  const notifications = ref([])

  function addNotification({ type = 'info', message, timeout = 5000 }) {
    const id = Date.now()
    notifications.value.push({ id, type, message })
    
    if (timeout) {
      setTimeout(() => {
        removeNotification(id)
      }, timeout)
    }
  }

  function removeNotification(id) {
    notifications.value = notifications.value.filter(n => n.id !== id)
  }

  return {
    notifications,
    addNotification,
    removeNotification
  }
})
